import { warnAboutMissingStyles } from '@entur/utils';
import React from 'react';
import classnames from 'classnames';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var _excluded$2 = ["item", "container", "children", "className", "spacing", "rowSpacing", "small", "medium", "large", "as"];
var defaultElement$2 = 'code';
var BaseGrid = function BaseGrid(_ref) {
  var _ref2, _ref3, _ref4, _ref5, _ref6;
  var item = _ref.item,
    container = _ref.container,
    children = _ref.children,
    className = _ref.className,
    spacing = _ref.spacing,
    rowSpacing = _ref.rowSpacing,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? 1 : _ref$small,
    medium = _ref.medium,
    large = _ref.large,
    as = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var Element = as || defaultElement$2;
  var classList = classnames(['eds-grid', className, {
    'eds-grid__item': item
  }, {
    'eds-grid__container': container
  }, (_ref2 = {}, _ref2["eds-grid--spacing-" + spacing] = spacing && container, _ref2), (_ref3 = {}, _ref3["eds-grid--spacing-row-" + rowSpacing] = spacing !== rowSpacing, _ref3), (_ref4 = {}, _ref4["eds-grid--small-" + small] = small && item, _ref4), (_ref5 = {}, _ref5["eds-grid--medium-" + medium] = medium && item, _ref5), (_ref6 = {}, _ref6["eds-grid--large-" + large] = large && item, _ref6)]);
  return React.createElement(Element, _extends({
    className: classList
  }, rest), children);
};
var _excluded$1 = ["children", "className", "small", "medium", "large", "as"];
var defaultElement$1 = 'div';
var GridItem = function GridItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    small = _ref.small,
    medium = _ref.medium,
    large = _ref.large,
    as = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var Element = as || defaultElement$1;
  return React.createElement(BaseGrid, _extends({
    as: Element,
    item: true,
    className: className,
    small: small,
    medium: medium,
    large: large
  }, rest), children);
};
var _excluded = ["children", "className", "spacing", "rowSpacing", "as"];
var defaultElement = 'div';
var GridContainer = function GridContainer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    spacing = _ref.spacing,
    rowSpacing = _ref.rowSpacing,
    as = _ref.as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var Element = as || defaultElement;
  return React.createElement(BaseGrid, _extends({
    container: true,
    as: Element,
    className: className,
    spacing: spacing,
    rowSpacing: rowSpacing
  }, rest), children);
};
warnAboutMissingStyles('grid');
export { GridContainer, GridItem };